import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { FormModeProvider } from '../../base/contexts/FormModeContext.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'
import { Loadable } from '../base/components/Lodable.tsx'
import { DeaInputProps } from './interfaces'
import { DeaFormMode, deaFormModeConfig, deaFormModeDefault } from './services/deaFormMode.ts'

const DeaGestion = Loadable(lazy(() => import('./view/DeaGestion.tsx')))
const DeaNuevoRegistro = Loadable(lazy(() => import('./view/nuevo/DeaNuevoRegistro.tsx')))
const DeaActualizar = Loadable(lazy(() => import('./view/actualizar/DeaActualizar.tsx')))
const DeaGestionAprobar = Loadable(lazy(() => import('./view/DeaGestionAprobar.tsx')))
const DeaGestionValidar = Loadable(lazy(() => import('./view/DeaGestionValidar.tsx')))
const DeaGestionConsultar = Loadable(lazy(() => import('./view/DeaGestionConsultar.tsx')))
const DeaAprobar = Loadable(lazy(() => import('./view/consultar/DeaAprobar.tsx')))
const DeaValidar = Loadable(lazy(() => import('./view/consultar/DeaValidar.tsx')))
const DeaConsultar = Loadable(lazy(() => import('./view/consultar/DeaConsultar.tsx')))
const DeaRegistroRapido = Loadable(lazy(() => import('./view/nuevo/DeaRegistroRapido.tsx')))
const DeaGestionRapida = Loadable(lazy(() => import('./view/DeaGestionRapida.tsx')))
const DeaRegistroLimpieza = Loadable(lazy(() => import('./view/nuevo/DeaRegistroLimpieza.tsx')))
export const deaRoutesMap = {
  gestion: {
    path: '/destruccion/gestion',
    name: 'Registrar',
    action: 'DESTRUCCION_ARTICULO',
  },
  nuevo: {
    path: '/destruccion/nuevo',
    name: 'Nuevo Registro',
    action: 'DESTRUCCION_ARTICULO_NUEVO',
  },
  registroRapido: {
    path: '/destruccion/rapido',
    name: 'Registro Rápido',
    action: 'DESTRUCCION_ARTICULO_REGISTRO_RAPIDO',
  },

  actualizar: {
    path: '/destruccion/actualizar/:id',
    name: 'Actualizar',
    action: 'DESTRUCCION_ARTICULO_ACTUALIZAR',
  },
  consultar: {
    path: '/destruccion/consultar/:id',
    name: 'Consultar Destrucción',
    action: 'DESTRUCCION_ARTICULO_CONSULTAR',
  },
  aprobar: {
    path: '/destruccion/aprobar/:id',
    name: 'Aprobar Destrucción',
    action: 'DESTRUCCION_ARTICULO_APROBAR',
  },
  validar: {
    path: '/destruccion/validar/:id',
    name: 'Validar Destrucción',
    action: 'DESTRUCCION_ARTICULO_VALIDAR',
  },
  gestionAprobar: {
    path: '/destruccion/aprobar',
    name: 'Aprobar',
    action: 'DESTRUCCION_GESTION_APROBAR',
  },
  gestionValidar: {
    path: '/destruccion/validar',
    name: 'Validar',
    action: 'DESTRUCCION_GESTION_VALIDAR',
  },
  gestionConsultar: {
    path: '/destruccion/consultar',
    name: 'Consultar',
    action: 'DESTRUCCION_ARTICULO_CONSULTAR',
  },
  gestionRapida: {
    path: '/destruccion/rapida',
    name: 'Registro Rápido',
    action: 'DESTRUCCION_ARTICULO_GESTION_RAPIDA',
  },
  registroLimpieza: {
    path: '/destruccion/limpieza',
    name: 'Registro por Limpieza',
    action: 'DESTRUCCION_ARTICULO_REGISTRO_LIMPIEZA',
  },
}

const deaRoutes = [
  {
    path: deaRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <DeaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.nuevo.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'create'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaNuevoRegistro />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'edit'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaActualizar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.gestionAprobar.path,
    element: (
      <OperacionesProvider>
        <DeaGestionAprobar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.gestionValidar.path,
    element: (
      <OperacionesProvider>
        <DeaGestionValidar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.gestionConsultar.path,
    element: (
      <OperacionesProvider>
        <DeaGestionConsultar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'consult'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaConsultar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.validar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'consult'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaValidar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.aprobar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'consult'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaAprobar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.registroRapido.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'create'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaRegistroRapido />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.gestionRapida.path,
    element: (
      <OperacionesProvider>
        <DeaGestionRapida />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.registroLimpieza.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode="cleanup"
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaRegistroLimpieza />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default deaRoutes
